<div wnlGroup #wnlGroup="wnlGroup">
  <div class="wnl-header">
    <p>
      WNL: Interactive with staff, appropriate judgement for developmental age, no suicidal ideation
      expressed. Mood stable and fitting for situation.
    </p>

    <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
      (change)="wnlGroup.setAllWnl($event.checked)"
      [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
      All Within Normal Limits
    </mat-checkbox>
  </div>

  <assessment-row title="Mood">
    <emr-checkbox-group [control]="formGroup().controls.mood" [options]="moodOptions" [wnlControl]="'mood'"
      [wnlDefault]="[]" [wnlClearValue]="null" />
  </assessment-row>

  <assessment-row title="Suicidal thoughts/expression?">
    <emr-checkbox [control]="formGroup().controls.suicidal" label="Yes" [wnlControl]="'suicidal'"
      [wnlDefault]="false" />
  </assessment-row>

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" [wnlClearValue]="null" />
  </assessment-row>
</div>